import ChannelsPanelList from "./channels-panel-list";

export default ChannelsPanelList;